import { Backdrop, CircularProgress } from "@mui/material";
import { useSelector } from "react-redux";
export default function Loading() {
  const { loading } = useSelector((state) => state.globalStates);
  return (
    <div>
      <Backdrop
        sx={{
          color: "#087a75",
          zIndex: (theme) => theme.zIndex.drawer + 10000000000,
        }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}
